<template>
    <div v-if="isNeededToShowPopup" class="newsletter-popup">
        <div class="text-block">
            <button class="modalClose" @click="closePopup">
                <svg-icon icon-class="bbb" icon-name="icon-cross"></svg-icon>
            </button>

            <svg>
                <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="/i/newsletter_icon.svg#Laag_1"></use>
            </svg>

            <div class="top-text">
                Become a true insider of FUTURUM Quality Gear!
                Subscribe to our newsletter and get a
            </div>

            <div class="title">20% discount</div>

            <div class="text">
                on your order above €100
            </div>

            <div class="form-container footerNewsletter">
                <div>
                    <input v-if="!successfullySent" v-model="inputValue" @change="inputOnChange" class="text" type="text" name="email"
                           placeholder="Please fill in your email address">
                    <div v-else class="notification newsletter success">
                        <div class="text-success-title">success!</div>
                        <div class="text">
                            Please have a look in your mailbox to
                            find the discount code for 20% off.
                        </div>
                    </div>
                    <button v-if="!successfullySent" @click="subscribeClick" name="subscribe"
                            :class="['button', 'medium', 'ghostWhite', 'check-form', {'isErrorLongText': isErrorLongText()}]">
                        <span>Subscribe</span>
                    </button>
                </div>
                <div v-if="errorAppeared" :class="['notice', 'notice-error', {'isErrorLongText': isErrorLongText()}]">
                    <div class="icon"><img src="/svg/icon-error.svg" alt=""></div>
                    <div class="text">{{errorAppeared}}</div>
                </div>
            </div>
        </div>

        <div class="newsletter-popup-background"></div>
    </div>
</template>

<script>
    import SvgIcon from './SvgIcon';
    import common from './../module/common'
    import FormSystemError from '../../../frontend/src/utils/form-error-constants';

    let formSystemError = new FormSystemError({});

    let showBackground = () => {
        that.$root.showNewsLetterPopup = true;
    };

    let mouseHandler = (event) => {
        if (event.clientY < 0) {
            that.isNeededToShowPopup = true;
            common.setCookie('newsLetterPopup', 'newsLetterPopup', 3);
            $("html").unbind('mouseleave', mouseHandler);
            showBackground();
        }
    };

    let that;

    export default {
        data: () => {
            return {
                isNeededToShowPopup: false,
                inputValue: "",
                successfullySent: false,
                errorAppeared: false
            }
        },
        components: {
            SvgIcon
        },
        methods: {
            isErrorLongText(){
                return this.errorAppeared && ( this.errorAppeared !== formSystemError.constants.field_required )
            },
            inputOnChange() {
                this.errorAppeared = false;
            },
            closePopup: (event) => {
                event.preventDefault();
                that.isNeededToShowPopup = false;
                that.$root.showNewsLetterPopup = false;
            },
            subscribeClick() {
                if(!this.inputValue){
                    this.errorAppeared = formSystemError.constants.field_required;
                    return;
                }

                grecaptcha.execute(window.recaptchaSitekeyV3, {action: 'newsletter'}).then(function (token) {
                    common.sendNewsletterRequest({
                        email: that.inputValue,
                        'recaptcha-response-v3': token
                    }).done((response) => {
                        if((response.statusCode === 2) || (response.statusCode === 1)) {
                            that.successfullySent = true;
                        }

                        if(response.statusCode === 0 || response.statusCode === 3) {
                            that.errorAppeared =  formSystemError.constants.clang_newsletter_subscription_failed;
                        }
                    });
                });
            }
        },
        created() {
            that = this;
            let newsLetterCookies = common.getCookie('newsLetterPopup');

            if (!newsLetterCookies) {
                $("html").bind('mouseleave', mouseHandler);
            }
        }
    }
</script>
